import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import QuoteProductDetail from '../../../quotes/entities/quoteProductDetail';
import ProductThumbSelectionViewComponent from '../../../quotes/review/quote-products/ProductThumbSelectionViewComponent';
import QuoteView from '../../../quotes/view/quoteView';
import ProductTineConfigurationView from '../../../quotes/review/quote-products/ProductTineConfigurationView';

export default class ProductThumbSpecificationsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  static propTypes = {
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
    productGroupName: PropTypes.string.isRequired,
    quote: PropTypes.instanceOf(QuoteView).isRequired,
  };

  show() {
    this.setState({ show: true });
  }

  hide = () => this.setState({ show: false });

  render() {
    const { entity, productGroupName, quote } = this.props;

    return (
      <SimpleModal show={this.state.show} size="lg">
        <ModalHeader title={`${productGroupName} - Thumb Specifications`} />
        <ModalBody>
          <ProductThumbSelectionViewComponent entity={entity} quote={quote} />
          {entity.tineDiagram && (
            <ProductTineConfigurationView entity={entity} />
          )}
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Close
          </button>
        </ModalFooter>
      </SimpleModal>
    );
  }
}
